import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useWindowSize } from 'react-use';
import { SectionData } from '@/types/home';
import { cn } from '@/lib/utils';
import DownloadInstagramContentSkeleton from './DownloadInstagramContentSkeleton';

const DownloadInstagramContent = ({ data }: { data?: SectionData }) => {
  const [currentData, setCurrentData] = useState(0);
  const { width } = useWindowSize();
  // CLS 优化：初始显示骨架屏，width 确定后同帧切换到真实内容
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // width > 0 表示 useWindowSize 已获取到真实宽度
    if (width > 0) {
      setIsReady(true);
    }
  }, [width]);

  if (!data) return null;

  return (
    // CLS 优化：骨架屏和内容在同一容器内同帧切换
    <div className={styles.content}>
      {!isReady ? (
        // 骨架屏
        <DownloadInstagramContentSkeleton hasDesc={!!data?.desc} cardCount={data?.cards?.length || 3} />
      ) : (
        // 真实内容
        <>
          {data?.title && <h2 className={cn(styles.title, { 'mb-[3.125rem]': !data?.desc })}>{data?.title}</h2>}

          {data?.desc && <p className="mt-8 mb-[3.125rem] text-[1.125rem] leading-6 text-center">{data?.desc}</p>}

          {data?.cards?.length > 0 && (
            <div className={styles.contentList}>
              {data?.cards?.map((item, index) => (
                <div
                  className={classNames(styles.contentItem, {
                    [styles.unSelected]: width <= 768 && index !== currentData,
                  })}
                  key={index}
                  onClick={() => width <= 768 && setCurrentData(index)}
                >
                  <div
                    className={classNames(styles.contentItemTitle, {
                      [styles.selected]: (width <= 768 && index === currentData) || width > 768,
                    })}
                  >
                    <span className={styles.subIndex}>{index + 1}</span>
                    <h3 className={styles.subTitle}>{item.title}</h3>
                    {((width <= 768 && index === currentData) || width > 768) && (
                      <span className={styles.subDesc}>{item.desc}</span>
                    )}
                  </div>
                  <div className={styles.contentItemImg}>
                    <Image
                      src={item.imgPath}
                      alt="download-instagram-content"
                      width={64}
                      height={64}
                      layout="responsive"
                    />
                  </div>

                  {width <= 768 && index !== currentData && (
                    <div className={styles.downArrowIcon}>
                      <DownOutlined />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DownloadInstagramContent;
